import { ProjectTechnicalModule } from '@gp/enums/project';
import { TECHNICAL_MODULE_KEYS } from '../const';

export const initializeTechnicalModuleValues = <T>(
  moduleCommonValue: T,
  moduleSpecialValue?: (module: ProjectTechnicalModule) => Partial<T>,
): Record<ProjectTechnicalModule, T> => {
  return TECHNICAL_MODULE_KEYS.reduce((acc, cur) => {
    const curValue = { ...moduleCommonValue, ...moduleSpecialValue?.(cur) };
    return { ...acc, [cur]: curValue };
  }, {}) as Record<ProjectTechnicalModule, T>;
};
